<ng-template #risklineTripReadyModalForm let-modal>

  <app-modal-comp-header
    [title]="modalTitle"
    (cancelButtonOnClick)="cancelForm()"
  ></app-modal-comp-header>

  <div class="modal-body" appModalResizable>
    @if (showPanel) {
      <app-trip-ready-panel
        [autoGenerate]="true"
        [initialDestIso]="destinationIso"
        [initialFromDate]="fromDate"
        [initialOriginIso]="originIso"
        [initialToDate]="toDate"
        lockMode="landing"
      ></app-trip-ready-panel>
    }
  </div>

  <div class="modal-footer trip-ready-modal-footer">
    <div class="trip-ready-modal-footer-text">
      <app-riskline-attribution [compact]="true"></app-riskline-attribution>
    </div>
    <button type="button" class="btn btn-light" (click)="cancelForm()">Close</button>
  </div>
</ng-template>
